import React from 'react'
import oikosApi from "../../services/oikos";
import { useSelector } from "react-redux";
import qs from "qs";
import { Box, IconButton, TextareaAutosize, TextField, Typography } from "@mui/material";
import MaterialReactTable from "material-react-table";
import moment from "moment";
import { Assignment, Edit, GetApp, PostAdd } from "@material-ui/icons";
import ModalFormContrFornEventos from "../../components/Modals/ModalFormContrFornEventos/ModalFormContrFornEventos";
import ModalContrFornInfo from '../../components/Modals/ModalContrFornInfo/ModalContrFornInfo';
import ContrFornParcelasTable from './ContrFornParcelasTable';
import ModalConfirmacao from '../../components/Modals/ModalConfirmacao/ModalConfirmacao';
import AddFiles from '../../components/Template/Files/AddFiles';
import { notifyError, notifySuccess } from '../../utils/notify';
import { downloadFile } from '../../utils/fc';
import { getOikosFileUrl } from '../../utils/linksOikos/link';
import DatePicker from 'react-datepicker'
import { Button, Col, FormGroup, Label, Row, Spinner } from 'reactstrap';
import {
  buildContrFornQueryString,
  enrichEventosWithArquivos,
  enrichEventosWithContrato,
  fetchContrFornEventosWithBordero,
  fetchMinutaContratoArquivo,
} from './contratosTabHelpers';
import {
  calcDtPrevFromAssinatura,
  hasEntregavelDtPrev,
  isPrazoDiasInformado,
} from '../../components/Modals/ModalFormContrForn/contrFornEntregaveisUtils';
import { COMPRA_STATUS_INFO_ENVIADA } from '../../components/Template/Doc/compraCotacaoTableUtils';
import ModalAditarContrForn from './ModalAditarContrForn';
import { agruparAditivos, rotuloAditivo } from './aditarContrForn';

function ContratosTab(props) {
  const [contratosFornecedores, setContratosFornecedores] = React.useState([]);
  const [contrFornData, setContrFornData] = React.useState({});
  const [openModalDocumentoAssinado, setOpenModalDocumentoAssinado] = React.useState(false);
  const [filesContrForn, setFilesContrForn] = React.useState([]);
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [loadingDraftId, setLoadingDraftId] = React.useState(null);
  const [loadingMinutaId, setLoadingMinutaId] = React.useState(null);
  const [contrForns, setContrForns] = React.useState([]);
  const [contrFornDetails, setContrFornDetails] = React.useState({});
  const [fornecedorDetails, setFornecedorDetails] = React.useState({});
  const [listaParcelasDetails, setListaParcelasDetails] = React.useState({});
  const [parcelasLoadingIds, setParcelasLoadingIds] = React.useState({});
  const [expanded, setExpanded] = React.useState({});
  const [aditarContrato, setAditarContrato] = React.useState(null);
  const [pagination, setPagination] = React.useState({ pageIndex: 0, pageSize: 50 });
  const [autoActionContrFornId, setAutoActionContrFornId] = React.useState(null);
  const tableInstanceRef = React.useRef(null);
  const autoActionTriggeredRef = React.useRef(false);
  const parcelasArquivosReqRef = React.useRef({});
  const { user } = useSelector(state => state.auth);
  const expandContrFornId = props.expandContrFornId ? String(props.expandContrFornId) : null;
  const expandCompraCotacaoId = props.expandCompraCotacaoId ? String(props.expandCompraCotacaoId) : null;
  const expandContrFornRequestKey = props.expandContrFornRequestKey || 0;
  const tableData = React.useMemo(() => (
    props.selectedCcId ? contratosFornecedores.filter(c => c.centroDeCustoRubr_id == props.selectedCcId) : contratosFornecedores
  ), [contratosFornecedores, props.selectedCcId]);

  const handleDownloadMinuta = async (contrato) => {
    const contrFornId = Number(contrato?.contrForn_id);
    if (!contrFornId) {
      notifyError('Contrato não encontrado.');
      return;
    }

    try {
      setLoadingMinutaId(contrFornId);
      const arquivoCaminho = (await fetchMinutaContratoArquivo(oikosApi, contrFornId))?.arquivo_caminho;

      if (!arquivoCaminho) {
        notifyError('Minuta de Contrato não encontrada para este contrato.');
        return;
      }

      const fileUrl = getOikosFileUrl(arquivoCaminho);
      const ext = String(arquivoCaminho).split('.').pop() || 'pdf';
      const safeNum = String(contrato.contrForn_num || contrFornId).replace(/[^\w.-]+/g, '_');
      await downloadFile(fileUrl, `minuta_${safeNum}.${ext}`);
    } catch (error) {
      console.error('Erro ao baixar minuta do contrato:', error);
      notifyError('Não foi possível baixar a minuta do contrato.');
    } finally {
      setLoadingMinutaId(null);
    }
  };

  const scrollContrFornIntoView = React.useCallback((contrFornId) => {
    setTimeout(() => {
      const rowElement = document.getElementById(`contr-forn-row-${contrFornId}`);
      if (rowElement) {
        rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 150);
  }, []);

  // States for CC Budget Summary
  const [ccBudgetSummary, setCcBudgetSummary] = React.useState(null);
  const [ccBudgetLoading, setCcBudgetLoading] = React.useState(false);
  const columns = [
    {
      accessorKey: 'contrForn_num',
      header: 'Número',
      size: 100,
      maxWidth: 200,
    },
    {
      accessorKey: 'contrForn_desc',
      header: 'Descrição',
      size: 100,
    },
    {

      id: 'nomeFornecedor',


      header: 'Nome Fornecedor',



      accessorFn: (row) => {



        return row.contratado_nomePj || row.contratado_nomePf || '';
      },


      enableColumnFilter: true,

      size: 150,
    },
    {
      accessorKey: 'contrForn_vlrGlobal',
      header: 'Valor',
      accessorFn: (row) => {
        if (row.contrForn_vlrGlobal) {
          return parseFloat(row.contrForn_vlrGlobal).toFixed(2);
        } else {
          return '0.00';
        }
      },
      Cell: ({ cell, row }) => {
        const value = cell.getValue();
        return value ? `R$ ${parseFloat(value).toFixed(2).replace('.', ',')}` : 'R$ 0,00';
      },
      size: 100,
    },
    {
      accessorKey: 'contrForn_dtAssin',
      header: 'Data Assinatura',
      accessorFn: (row) => {
        if (row.contrForn_dtAssin) {
          return moment(row.contrForn_dtAssin, 'YYYY-MM-DD').toDate();
        } else {
          return null;
        }
      },
      size: 100,
      sortingFn: 'datetime',
      Cell: ({ cell, row }) => {
        if (row.original.contrForn_dtAssin) {
          return moment(cell.getValue()).format('DD/MM/YYYY')
        }
      }, // Format Date for display
    },
    {
      accessorKey: 'contrForn_dtVigIni',
      header: 'Início Vigência',
      accessorFn: (row) => {
        if (row.contrForn_dtVigIni) {
          return moment(row.contrForn_dtVigIni, 'YYYY-MM-DD').toDate();
        } else {
          return null;
        }
      },
      size: 100,
      sortingFn: 'datetime',
      Cell: ({ cell, row }) => {
        if (row.original.contrForn_dtVigIni) {
          return moment(cell.getValue()).format('DD/MM/YYYY')
        }
      }, // Format Date for display
    },
    {
      accessorKey: 'contrForn_dtVigFim',
      header: 'Fim Vigência',
      accessorFn: (row) => {
        if (row.contrForn_dtVigFim) {
          return moment(row.contrForn_dtVigFim, 'YYYY-MM-DD').toDate();
        } else {
          return null;
        }
      },
      size: 100,
      sortingFn: 'datetime',
      Cell: ({ cell, row }) => {
        if (row.original.contrForn_dtVigFim) {
          return moment(cell.getValue()).format('DD/MM/YYYY')
        }
      }, // Format Date for display
    },
    {
      accessorKey: 'orcItem_desc',
      header: 'Item Orçamentário',
      accessorFn: (row) => {
        if (row.orcItem_desc) {
          return row.orcItem_desc
        } else {
          return null;
        }
      },
      size: 100,
      sortingFn: 'alphanumeric',
      Cell: ({ cell, row }) => {
        if (row.original.orcItem_desc) {
          return cell.getValue()
        }
      }, // Format Date for display
    },

    {
      accessorKey: 'contrFornStatus_nome',
      header: 'Status',
      accessorFn: (row) => {
        if (row.contrFornStatus_nome) {
          return row.contrFornStatus_nome
        } else {
          return null;
        }
      },
      size: 100,
      sortingFn: 'alphanumeric',
      Cell: ({ cell, row }) => {
        if (row.original.contrFornStatus_nome) {
          return cell.getValue()
        }
      }, // Format Date for display
    },
    {
      accessorKey: 'contrFornTp_nome',
      header: 'Tipo',
      accessorFn: (row) => {
        if (row.contrFornTp_id) {
          return row.contrFornTp_nome
        } else {
          return null;
        }
      },
      size: 100,
      sortingFn: 'alphanumeric',
      Cell: ({ cell, row }) => {
        if (row.original.contrFornTp_nome) {
          return cell.getValue()
        }
      }, // Format Date for display
    },
    {
      header: 'Ações',
      size: 120,
      // REMOVIDO O accessorFn e substituído por Cell para pegar os dados brutos corretamente
      Cell: ({ row }) => {
        const contrato = row.original; // Acessa os dados originais da linha

        return (
          <div className="d-flex">
            {/* 1. SE FOR RASCUNHO (Status 1), MOSTRA O BOTÃO DE EDITAR */}

            {Number(contrato.contrFornStatus_id) === 1 &&
              (
                !(loadingDraftId === contrato.contrForn_id) ?
                <IconButton
                  color="primary"
                  onClick={async () => {
                    console.log("ID capturado do contrato:", contrato.contrForn_id); // Log para conferência
                    if (props.handleEditDraft) {
                      setLoadingDraftId(contrato.contrForn_id);
                      await props.handleEditDraft(contrato.contrForn_id); // Passa o ID correto
                      setLoadingDraftId(null);
                    } else {
                      console.error("Função handleEditDraft não recebida nas props");
                    }
                  }}
                >
                  <Edit />
                </IconButton> :
                <Spinner />
              )
            }

            {/* 2. OUTROS STATUS: INFO */}
            {[8, 2, 10].includes(Number(contrato.contrFornStatus_id)) &&
              <ModalContrFornInfo
                autoOpen={autoActionContrFornId != null && Number(autoActionContrFornId) === Number(contrato.contrForn_id)}
                contrFornData={contrato}
                setListaParcelasDetails={setListaParcelasDetails}
                updateOneEvento={async (data, rowId) => await updateOneEvento(data, rowId)}
              />
            }

            {/* 3. ASSINATURA */}
            {Number(contrato.contrFornStatus_id) === 7 &&
              <>
                {loadingMinutaId === contrato.contrForn_id ? (
                  <Spinner size="sm" className="mr-1" />
                ) : (
                  <IconButton
                    color="primary"
                    title="Baixar minuta"
                    onClick={() => handleDownloadMinuta(contrato)}
                  >
                    <GetApp />
                  </IconButton>
                )}
                <IconButton
                  title="Anexar contrato assinado"
                  onClick={() => {
                    setContrFornData(contrato)
                    setOpenModalDocumentoAssinado(true)
                  }}
                >
                  <Assignment />
                </IconButton>
              </>
            }

            {/* 4. EVENTOS/PAGAMENTOS */}
            {[9, 3, 4, 5, 6].includes(Number(contrato.contrFornStatus_id)) &&
              <ModalFormContrFornEventos
                autoOpen={autoActionContrFornId != null && Number(autoActionContrFornId) === Number(contrato.contrForn_id)}
                fetchContratosFornecedores={fetchContratosFornecedores}
                contrFornData={contrato}
              />
            }

            {/* {Number(contrato.contrFornStatus_id) === 2 && !((contrato.aditivos || []).some((aditivo) => ![3, 4, 9, 11].includes(Number(aditivo.contrFornStatus_id)))) &&
              <IconButton color="primary" title="Aditar" onClick={() => setAditarContrato(contrato)}>
                <PostAdd />
              </IconButton>
            } */}
            {((contrato.aditivos || []).find((aditivo) => Number(aditivo.contrFornStatus_id) === 7)) &&
              <IconButton
                title="Anexar aditivo assinado"
                onClick={() => {
                  const aditivo = contrato.aditivos.find((item) => Number(item.contrFornStatus_id) === 7)
                  setContrFornData(aditivo)
                  setOpenModalDocumentoAssinado(true)
                }}
              >
                <Assignment />
              </IconButton>
            }
          </div>
        )
      }
    },
  ]
  const handleCloseModalDocumentoAssinado = () => {
    setFilesContrForn([]);
    setOpenModalDocumentoAssinado(false);
  }

  const fetchContratosFornecedores = async () => {
    if (!user) return
    try {
      const query = buildContrFornQueryString({
        user,
        proj_orcRubrId: props.proj_orcRubrId,
        proj_coord: props.proj_coord,
        filterMeusFornecedores: props.filterMeusFornecedores,
      })
      if (!query) return

      const response = await oikosApi.get(`/?${query}`)

      console.log('response', response)

      const rows = (response.data || []).map((item) => ({
        ...item,
        contrato_vigente: Number(item.contrato_vigente),
      }))

      setContratosFornecedores(agruparAditivos(rows))
      console.log('Fornecedores fetched:', response)
    } catch (error) {
      console.error('Error fetching fornecedores:', error)
    }
  }

  const fetchContrFornEventos = async () => {
    if (!user) return; // Prevent running without user
    try {
      let response = {}
      let query = ''
      if (user.perm_id === 1) {

        if (props.proj_orcRubrId) {

          query = qs.stringify({
            action: 'get',
            table: 'contrFornEvento',
            data: {
              contrFornEvento_ativo: 1
            },
            fields: {
            }
          });
        } else {

          query = qs.stringify({
            action: 'get',
            table: 'contrForn',
            data: {
              contrFornEvento_ativo: 1,
            },
            fields: {}
          });
        }
      } else {
        if (props.proj_orcRubrId) {

          query = qs.stringify({
            action: 'get',
            table: 'contrForn',
            data: {
              contrFornEvento_ativo: 1,
            },
            fields: {}
          });

        } else {

          query = qs.stringify({
            action: 'get',
            table: 'contrForn',
            data: {
              contrFornEvento_ativo: 1,
            },
            fields: {}
          });

        }
      }
      response = await oikosApi.get(`/?${query}`);

      setContrForns(response.data || []);
      console.log("Fornecedores fetched:", response);
    } catch (error) {
      console.error("Error fetching fornecedores:", error);
    }
  };

  function verificaDocumentoAssinado() {
    if (filesContrForn.length <= 0) {
      notifyError('É obrigatório anexar o documento assinado')
      return false;
    }
    if (!contrFornData.contrForn_dtAssin) {
      notifyError('É obrigatório informar a data da assinatura')
      return false;
    }
    return true;
  }

  async function fetchEventosAtivosParaAssinatura(contrFornId) {
    const resParcelas = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'contrFornEvento',
      data: {
        contrForn_id: contrFornId,
        contrFornEvento_ativo: 1,
      },
      fields: {
        contrFornEvento_id: 'contrFornEvento_id',
        contrFornEvento_num: 'contrFornEvento_num',
        contrFornEvento_desc: 'contrFornEvento_desc',
        contrFornEvento_pgtoPrazoDias: 'contrFornEvento_pgtoPrazoDias',
        contrFornEvento_dtPrev: 'contrFornEvento_dtPrev',
      },
    })}`);
    return resParcelas?.data || [];
  }

  function assertEventosComAgendamentoCompleto(eventos) {
    const incompletos = (eventos || []).filter((evento) => (
      !hasEntregavelDtPrev(evento)
      && !isPrazoDiasInformado(evento.contrFornEvento_pgtoPrazoDias)
    ));

    if (incompletos.length === 0) return;

    const detalhe = incompletos
      .map((e) => e.contrFornEvento_desc || `Parcela ${e.contrFornEvento_num || e.contrFornEvento_id}`)
      .join(', ');
    notifyError(
      `Uma ou mais parcelas não possuem data prevista nem prazo para pagamento${detalhe ? `: ${detalhe}` : ''}.`,
    );
    throw new Error('contrFornEvento sem dtPrev e sem pgtoPrazoDias');
  }

  async function atualizarDtPrevEventosPorAssinatura(contrFornId, dtAssin, eventosPreCarregados) {
    const eventos = eventosPreCarregados || await fetchEventosAtivosParaAssinatura(contrFornId);
    assertEventosComAgendamentoCompleto(eventos);

    await Promise.all(eventos.map(async (evento) => {
      // Já tem data prevista: não recalcula (data fixa ou já materializada).
      if (hasEntregavelDtPrev(evento)) return;

      const prazoDias = Number.parseInt(String(evento.contrFornEvento_pgtoPrazoDias), 10);
      const dtPrev = calcDtPrevFromAssinatura(dtAssin, prazoDias);
      if (!dtPrev || !evento.contrFornEvento_id) return;

      await oikosApi.post('/', {
        action: 'update',
        table: 'contrFornEvento',
        data: {
          contrFornEvento_id: evento.contrFornEvento_id,
          contrFornEvento_dtPrev: dtPrev,
        },
      });
    }));
  }

  async function saveDocuments(files, contrFornRecord) {
    // Cria um registro na tabela de documentos para cada arquivo
    await Promise.all(files.map(async (file) => {
      const documentBody = {
        action: 'insert',
        table: 'documento',
        data: {
          tpDocumento_id: file.props.documentType.tpDocumento_id,
          documento_desc: file.data.path,
          documento_iniVig: undefined,
          documento_fimVig: undefined,
          documento_dtEmissao: undefined,
          documento_prazo: undefined,
          documento_ref: undefined,
          privacidade_id: 2,
        },
      }
      const documentCreated = await oikosApi.post('/', documentBody)

      // Cria uma vinculação entre o documento (anexo) e o registro da minuta
      if (documentCreated.data[0].documento_id) {
        const vinculationBody = {
          action: 'insert',
          table: 'documentoVinc',
          data: {
            documento_id: documentCreated.data[0].documento_id,
            documentoVinc_tabRef: 'contrForn',
            documentoVinc_tabId: contrFornRecord.contrForn_id,
          },
        }
        await oikosApi.post('/', vinculationBody)
      }

      // Faz upload do arquivo e registra na tabela 'arquivo'
      const formData = new FormData()
      formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
      formData.append('table', 'arquivo')
      formData.append('action', 'upload_file')
      formData.append('arquivo_tabRef', 'documento')
      formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
      formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
      formData.append('arquivo_desc', file.data.path)
      const fileUploadRes = await oikosApi.post('/', formData)
      console.tron.log('fileUploadRes', fileUploadRes)
    }))
  }

  async function vincularBdrosDasParcelas(contrFornId) {
    const resParcelas = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'contrFornEvento',
      data: {
        contrForn_id: contrFornId,
        contrFornEvento_ativo: 1,
      },
      fields: {
        contrFornEvento_id: 'contrFornEvento_id',
        bdro_id: 'bdro_id',
      }
    })}`);

    const parcelasComBdro = (resParcelas.data || []).filter(parcela => parcela.bdro_id);

    await Promise.all(parcelasComBdro.map(async (parcela) => {
      const postBody = {
        table: 'bdro',
        action: 'update',
        data: {
          bdro_id: parcela.bdro_id,
          bdro_tabRef: 'contrFornEvento',
          bdro_tabId: parcela.contrFornEvento_id,
        }
      };

      await oikosApi.post('/', postBody);
    }));
  }

  async function handleSubmitDocumentoAssinado() {
    setSubmitLoading(true)

    try {
      const checkDocumentoAssinado = verificaDocumentoAssinado();
      if (!checkDocumentoAssinado) return;

      if (Number(contrFornData.contrForn_original)) {
        await saveDocuments(filesContrForn, contrFornData)
        const aplicado = await oikosApi.post('/', {
          action: 'aplicar_aditivo_contrforn',
          table: 'contrForn',
          data: {
            contrForn_id: contrFornData.contrForn_id,
            contrForn_dtAssin: contrFornData.contrForn_dtAssin,
          },
        })
        if (aplicado?.data?.message) notifySuccess(aplicado.data.message)
        handleCloseModalDocumentoAssinado();
        return
      }

      const dtAssin = contrFornData.contrForn_dtAssin;
      const eventos = await fetchEventosAtivosParaAssinatura(contrFornData.contrForn_id);
      assertEventosComAgendamentoCompleto(eventos);

      await saveDocuments(filesContrForn, contrFornData)
      const postBody = {
        table: 'contrForn',
        action: 'update',
        data: {
          contrForn_id: contrFornData.contrForn_id,
          contrForn_dtAssin: dtAssin || undefined,
          contrFornStatus_id: 2
        }
      }
      await oikosApi.post('/', postBody);
      await atualizarDtPrevEventosPorAssinatura(contrFornData.contrForn_id, dtAssin, eventos);
      await vincularBdrosDasParcelas(contrFornData.contrForn_id);

      handleCloseModalDocumentoAssinado();
    } catch (error) {
      console.error('Erro ao anexar contrato assinado:', error);
      if (error?.message !== 'contrFornEvento sem dtPrev e sem pgtoPrazoDias') {
        notifyError('Não foi possível concluir o anexo do contrato assinado.');
      }
    } finally {
      setSubmitLoading(false)
    }
  }

  const loadParcelasForRow = async (contrFornId, contratoRow) => {
    const eventos = await fetchContrFornEventosWithBordero(oikosApi, contrFornId)
    return enrichEventosWithContrato(eventos, contratoRow)
  }

  const scheduleArquivosParcelas = (rowId, enriched) => {
    const precisaArquivos = enriched.some((evento) => (
      Number(evento.contrFornEvento_aprovLiberado) === 1
      || Number(evento.contrFornEvento_liberacaoAutomatica) === 1
    ))
    if (!precisaArquivos) return

    const reqId = (parcelasArquivosReqRef.current[rowId] || 0) + 1
    parcelasArquivosReqRef.current[rowId] = reqId

    enrichEventosWithArquivos(oikosApi, enriched)
      .then((withArquivos) => {
        if (parcelasArquivosReqRef.current[rowId] !== reqId) return
        const byId = Object.fromEntries(
          withArquivos.map((evento) => [String(evento.contrFornEvento_id), evento]),
        )
        setListaParcelasDetails((prev) => {
          const current = prev[rowId]
          if (!current) return prev
          return {
            ...prev,
            [rowId]: current.map((evento) => {
              const arquivos = byId[String(evento.contrFornEvento_id)]
              if (!arquivos) return evento
              return {
                ...evento,
                arquivo_caminho_evidencia: arquivos.arquivo_caminho_evidencia || null,
                arquivo_caminho_nota_fiscal: arquivos.arquivo_caminho_nota_fiscal || null,
              }
            }),
          }
        })
      })
      .catch((error) => {
        console.error('Failed to fetch arquivos das parcelas:', error)
      })
  }

  const getEventos = async (contrFornId, rowId, contratoRow) => {
    if (listaParcelasDetails[rowId] !== undefined || parcelasLoadingIds[rowId]) return

    setParcelasLoadingIds((prev) => ({ ...prev, [rowId]: true }))
    try {
      const enriched = await loadParcelasForRow(contrFornId, contratoRow)
      setListaParcelasDetails((prev) => ({ ...prev, [rowId]: enriched }))
      scheduleArquivosParcelas(rowId, enriched)
    } catch (error) {
      console.error('Failed to fetch parcelas details:', error)
    } finally {
      setParcelasLoadingIds((prev) => ({ ...prev, [rowId]: false }))
    }
  };

  const updateEventos = async (contrFornId, rowId) => {
    const contratoRow = contrFornDetails[rowId] || contratosFornecedores.find(
      (row) => String(row.contrForn_id) === String(rowId),
    )

    setParcelasLoadingIds((prev) => ({ ...prev, [rowId]: true }))
    try {
      const enriched = await loadParcelasForRow(contrFornId, contratoRow)
      setListaParcelasDetails((prev) => ({ ...prev, [rowId]: enriched }))
      scheduleArquivosParcelas(rowId, enriched)
    } catch (error) {
      console.error('Failed to fetch parcelas details:', error)
    } finally {
      setParcelasLoadingIds((prev) => ({ ...prev, [rowId]: false }))
    }
  };

  const getFornecedor = async (parteTab, parteId, rowId) => {
    if (!parteTab || !parteId) return

    try {
      const resFornecedor = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: parteTab,
        data: {
          [`${parteTab}_id`]: parteId,
          [`${parteTab}_ativo`]: 1
        }
      })}`)

      console.log('resFornecedor.data[0]', resFornecedor.data[0]);

      setFornecedorDetails((prev) => ({ ...prev, [rowId]: resFornecedor.data[0] }));

    } catch (error) {
      console.error("Failed to fetch parcelas details:", error);
    }
  };

  const updateOneEvento = async (contrFornEventoId, rowId) => {
    const resFornecedor = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'contrFornEvento',
      data: {
        contrFornEvento_id: contrFornEventoId,
        contrFornEvento_ativo: 1
      }
    })}`)

    const updatedRow = resFornecedor.data[0]
    let updatedList = []

    setListaParcelasDetails((prev) => {
      updatedList = (prev[rowId] || []).map((evento) => (
        evento.contrFornEvento_id === contrFornEventoId
          ? { ...evento, ...updatedRow }
          : evento
      ))
      return { ...prev, [rowId]: updatedList }
    })

    return updatedList
  }

  // whenever expansion changes, fetch for newly-expanded rows
  const onExpandedChange = React.useCallback((updater) => {
    setExpanded((prev) => {
      const next = typeof updater === 'function' ? updater(prev) : updater;
      Object.entries(next).forEach(([rowId, isOpen]) => {
        if (isOpen) {
          // If we already have data, skip
          if (!(rowId in listaParcelasDetails)) {
            // Find the row (since rowId is contrForn_id now)
            const row = contratosFornecedores.find(r => String(r.contrForn_id) === rowId);
            console.log('row', row)
            if (row) {
              getEventos(row.contrForn_id, rowId, row);
              getFornecedor(row.contrForn_parteTab, row.contrForn_parteId, rowId);
              setContrFornDetails((prev) => ({ ...prev, [rowId]: row }));
            }
          }
        }
      });
      return next;
    });
  }, [contratosFornecedores, listaParcelasDetails]);

  React.useEffect(() => {
    autoActionTriggeredRef.current = false;
    setAutoActionContrFornId(null);
  }, [expandContrFornId, expandCompraCotacaoId, expandContrFornRequestKey]);

  React.useEffect(() => {
    if ((!expandContrFornId && !expandCompraCotacaoId) || tableData.length === 0 || autoActionTriggeredRef.current) return;

    const rowIndex = tableData.findIndex((r) => (
      (expandContrFornId && String(r.contrForn_id) === expandContrFornId)
      || (expandCompraCotacaoId && String(r.compraCotacao_id) === expandCompraCotacaoId)
    ));
    const row = tableData[rowIndex];
    if (!row) return;

    autoActionTriggeredRef.current = true;
    const targetPageIndex = Math.floor(rowIndex / pagination.pageSize);

    setPagination(prev => ({
      ...prev,
      pageIndex: targetPageIndex,
    }));

    setTimeout(() => {
      if (tableInstanceRef.current) {
        tableInstanceRef.current.setPageIndex(targetPageIndex);
      }
      scrollContrFornIntoView(String(row.contrForn_id));

      const statusId = Number(row.contrFornStatus_id);
      const isPendingSupplierValidation = Number(row.compraStatus_id) === COMPRA_STATUS_INFO_ENVIADA;

      if ((statusId === 1 || isPendingSupplierValidation) && props.handleEditDraft) {
        const openDraft = async () => {
          setLoadingDraftId(row.contrForn_id);
          await props.handleEditDraft(row.contrForn_id);
          setLoadingDraftId(null);
        };

        openDraft();
        return;
      }

      if (statusId === 7) {
        setContrFornData(row);
        setOpenModalDocumentoAssinado(true);
        return;
      }

      setAutoActionContrFornId(row.contrForn_id);
    }, 50);
  }, [expandContrFornId, expandCompraCotacaoId, expandContrFornRequestKey, tableData, pagination.pageSize, scrollContrFornIntoView, props.handleEditDraft]);

  React.useEffect(() => {
    fetchContratosFornecedores()
  }, [props.forceRender, expandContrFornRequestKey])

  React.useEffect(() => {
    if (props.selectedCcId) {
      // Filter strictly by the exact ID (using == to handle string/number type diffs)
      const ccExactContracts = contratosFornecedores.filter(c => c.centroDeCustoRubr_id == props.selectedCcId);

      const fetchBudget = async () => {
        setCcBudgetLoading(true);
        try {
          const currentYear = new Date().getFullYear();

          // 1. Fetch Orcamento (orcCCusto)
          const orcRes = await oikosApi.get(`/?${qs.stringify({
            action: 'get',
            table: 'orcCCusto',
            data: {
              orcCCusto_ativo: 1,
              orcCCusto_ano: currentYear,
              orcRubr_id: props.selectedCcId
            }
          })}`);

          const orcTotal = (orcRes.data && orcRes.data.length > 0) ? Number(orcRes.data[0].orcCCusto_vlr || 0) : 0;

          // 2. Fetch Alocado (Soma das parcelas ativas de 2026 dos contratos desse CC)
          let alocadoTotal = 0;
          const contrFornIds = ccExactContracts.map(c => c.contrForn_id).filter(id => id);

          if (contrFornIds.length > 0) {
            const parcelasRes = await oikosApi.get(`/?${qs.stringify({
              action: 'get',
              table: 'contrFornEvento',
              data: {
                contrFornEvento_ativo: 1,
                contrForn_id: `!IN!(${contrFornIds.join(',')})`
              }
            })}`);

            if (parcelasRes.data && Array.isArray(parcelasRes.data)) {
              parcelasRes.data.forEach(parcela => {
                if (parcela.contrFornEvento_dtPrev && parcela.contrFornEvento_dtPrev.startsWith(String(currentYear))) {
                  alocadoTotal += Number(parcela.contrFornEvento_vlr || 0);
                }
              });
            }
          }

          // Pegar o nome direto da lista do Select do Dropdown para ignorar discrepancias das views do Oikos
          const foundCc = props.selCentroDeCusto ? props.selCentroDeCusto.find(cc => cc.value == props.selectedCcId) : null;
          const ccName = foundCc ? foundCc.label : (ccExactContracts.length > 0 ? ccExactContracts[0].centroDeCusto : `ID ${props.selectedCcId}`);

          setCcBudgetSummary({
            ccName: ccName,
            contratosCount: ccExactContracts.length,
            orcamento: orcTotal,
            alocado: alocadoTotal,
            disponivel: orcTotal - alocadoTotal
          });

        } catch (err) {
          console.error("Erro ao buscar resumo orcamentario", err);
        } finally {
          setCcBudgetLoading(false);
        }
      };
      fetchBudget();
    } else {
      setCcBudgetSummary(null);
    }
  }, [props.selectedCcId, contratosFornecedores]);

  return (
    <>
      {ccBudgetSummary && (
        <Box sx={{ p: 2, mb: 2, bgcolor: '#f8f9fa', borderRadius: '4px', border: '1px solid #dee2e6' }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
            Resumo do Centro de Custo: {ccBudgetSummary.ccName}
          </Typography>
          <Row>
            <Col sm={3}>
              <Typography variant="body2" color="textSecondary">Contratos Vinculados</Typography>
              <Typography variant="body1">{ccBudgetSummary.contratosCount}</Typography>
            </Col>
            <Col sm={3}>
              <Typography variant="body2" color="textSecondary">Orçamento 2026</Typography>
              <Typography variant="body1">
                {ccBudgetLoading ? <Spinner size="sm"/> : `R$ ${ccBudgetSummary.orcamento.toLocaleString('pt-BR', {minimumFractionDigits: 2})}`}
              </Typography>
            </Col>
            <Col sm={3}>
              <Typography variant="body2" color="textSecondary">Alocado 2026</Typography>
              <Typography variant="body1" color="error">
                {ccBudgetLoading ? <Spinner size="sm"/> : `R$ ${ccBudgetSummary.alocado.toLocaleString('pt-BR', {minimumFractionDigits: 2})}`}
              </Typography>
            </Col>
            <Col sm={3}>
              <Typography variant="body2" color="textSecondary">Saldo Disponível</Typography>
              <Typography variant="body1" color={ccBudgetSummary.disponivel >= 0 ? "primary" : "error"}>
                {ccBudgetLoading ? <Spinner size="sm"/> : `R$ ${ccBudgetSummary.disponivel.toLocaleString('pt-BR', {minimumFractionDigits: 2})}`}
              </Typography>
            </Col>
          </Row>
        </Box>
      )}
      <MaterialReactTable
        tableInstanceRef={tableInstanceRef}
        columns={columns}
        data={tableData}
        initialState={{
          density: 'compact',
          expanded: {}, //expand all groups by default
          sorting: [], //sort by state by default,
          columnVisibility: { contrForn_num: false, contrForn_dtAssin: false, contrForn_dtVigIni: false, contrForn_dtVigFim: false, orcItem_desc: false },
        }}
        enableColumnResizing={true}
        enableGrouping={false}
        enableGlobalFilter={true}
        enableFilters={true}
        getRowId={(row) => String(row.contrForn_id)}
        enablePagination={(tableData.length > pagination.pageSize)}
        muiTopToolbarProps={{ sx: { '.MuiBox-root': { marginTop: "10px", height: "20px", display: "flex", alignItems: "center" }, '.MuiSvgIcon-root': { width: '12px' }, '.MuiButtonBase-root': { padding: '5px 5px 5px 5px' } } }}
        state={{ expanded, pagination }}
        onPaginationChange={setPagination}
        autoResetPageIndex={false}
        muiTableBodyCellProps={{ sx: { fontSize: "13px" } }}
        muiTableBodyRowProps={({ row }) => ({
          id: `contr-forn-row-${row.id}`,
        })}
        muiTablePaginationProps={{
          sx: { '.MuiTablePagination-displayedRows': { fontSize: "12px" }, marginTop: "0px", fontSize: "12px" },
          labelRowsPerPage: <span style={{ fontSize: "12px" }}>Produtos por página</span>,
          rowsPerPageOptions: [50, 100],
        }}
        positionPagination='bottom'
        muiTableHeadCellColumnActionsButtonProps={{ size: "8px" }}
        enableRowExpansion={true}
        onExpandedChange={onExpandedChange}
        renderDetailPanel={({ row }) => {
          const parcelas = listaParcelasDetails[row.id]
          const contrFornId = String(row.original.contrForn_id)

          const aditivos = row.original.aditivos || []
          return (
            <>
            {aditivos.length > 0 && (
              <div style={{ padding: '8px 12px 0' }}>
                {aditivos.map((aditivo) => (
                  <div key={aditivo.contrForn_id} className="d-flex align-items-center justify-content-between mb-1">
                    <span>
                      {aditivo.contrForn_num}
                      {' · '}
                      {rotuloAditivo(aditivo.contrForn_aditivoTp)}
                      {' · '}
                      {aditivo.contrFornStatus_nome || 'Aditivo'}
                    </span>
                    {Number(aditivo.contrFornStatus_id) === 7 && (
                      <Button size="sm" color="primary" onClick={() => {
                        setContrFornData(aditivo)
                        setOpenModalDocumentoAssinado(true)
                      }}>
                        Anexar assinado
                      </Button>
                    )}
                  </div>
                ))}
              </div>
            )}
            <ContrFornParcelasTable
              data={parcelas || []}
              isLoading={!!parcelasLoadingIds[row.id] || parcelas === undefined}
              contrFornData={contrFornDetails[row.id] || row.original}
              fornecedor={fornecedorDetails[row.id] || {}}
              onParcelasChange={(next) => setListaParcelasDetails((prev) => ({ ...prev, [row.id]: next }))}
              getEventos={() => updateEventos(row.original.contrForn_id, row.id)}
              updateOneEvento={updateOneEvento}
              onContrFornParteUpdated={(nextContrForn) => {
                setContrFornDetails((prev) => ({
                  ...prev,
                  [contrFornId]: {
                    ...(prev[contrFornId] || {}),
                    ...nextContrForn,
                  },
                }));
                setListaParcelasDetails((prev) => ({
                  ...prev,
                  [contrFornId]: enrichEventosWithContrato(prev[contrFornId] || [], nextContrForn),
                }));
              }}
            />
            </>
          );
        }}
        enableDensityToggle={false}
        enableColumnFilters={false}
        muiTableHeadCellProps={{
          sx: {
            '.MuiSvgIcon-root': { fontSize: "18px" },
            fontSize: '12px',
            fontWeight: 'normal', // Remove bold text in the header
            padding: '8px', // Adjust padding to reduce white space
          },
        }}
      />
      <ModalAditarContrForn
        contrato={aditarContrato}
        user={user}
        onClose={() => setAditarContrato(null)}
        onSaved={fetchContratosFornecedores}
      />
      <ModalConfirmacao
        title={Number(contrFornData.contrForn_original) ? 'Anexar aditivo assinado' : 'Anexar contrato assinado'}
        text={Number(contrFornData.contrForn_original) ? 'Anexe o aditivo assinado no campo abaixo' : 'Anexe o contrato assinado no campo abaixo'}
        openModal={openModalDocumentoAssinado}
        onClosed={() => setOpenModalDocumentoAssinado(false)}
        isLoading={submitLoading}
        childComponent={
          <>
            <Col>
              <FormGroup>
                <Label>
                  Data da assinatura
                </Label>
                <DatePicker
                  placeholderText="__/__/_____"
                  locale="pt-BR"
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  selected={contrFornData.contrForn_dtAssin ? moment(contrFornData.contrForn_dtAssin).toDate() : null}
                  onChange={date => {
                    if (date) {
                      setContrFornData({ ...contrFornData, contrForn_dtAssin: moment(date).format('YYYY-MM-DD') })
                    } else {
                      setContrFornData({ ...contrFornData, contrForn_dtAssin: null });
                    }
                  }}
                />
              </FormGroup>
            </Col>
            <AddFiles
              multiple={true}
              //accept={['.pdf']}
              files={filesContrForn} // Pass state
              onFilesChange={setFilesContrForn} // Update state
            />
          </>
        }
        onConfirm={async () => {
          await handleSubmitDocumentoAssinado();
          await fetchContratosFornecedores();
        }}
      />
    </>
  )
}

export default ContratosTab
